import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ArrowUpRight } from 'lucide-react';
import { SITE, SERVICES, NAV_LINKS } from '../lib/site';

const Footer = () => {
  return (
    <footer className="bg-ink text-paper pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6">
        {/* Columna principal */}
        <div className="grid md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1.2fr] gap-12 pb-14 border-b border-paper/10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-light.png" alt="HGO Servicios" className="h-12 w-auto" width={152} height={48} loading="lazy" />
            </div>
            <p className="mt-5 text-paper/55 text-sm leading-relaxed max-w-sm">
              Empresa de construcción, reformas integrales y mantenimiento en Málaga y
              la Costa del Sol. Equipos propios, garantía por escrito y presupuesto gratis en 24h.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { label: 'Instagram', href: SITE.social.instagram, glyph: 'IG' },
                { label: 'Facebook', href: SITE.social.facebook, glyph: 'FB' },
                { label: 'WhatsApp', href: `https://wa.me/${SITE.whatsapp}`, glyph: 'WA' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="grid place-items-center w-10 h-10 rounded-[3px] border border-paper/20 text-[0.62rem] font-bold tracking-widest hover:bg-clay hover:border-clay hover:text-white transition-all duration-200 active:scale-95"
                >
                  {s.glyph}
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="Navegación del pie">
            <h4 className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-paper/40 mb-5">Navegación</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-paper/70 hover:text-paper text-sm transition-colors inline-flex items-center gap-1.5 group">
                    {l.label}
                    <ArrowUpRight size={13} className="text-clay-light opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200" />
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/presupuesto" className="text-paper/70 hover:text-paper text-sm transition-colors">Presupuesto gratis</Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Servicios del pie">
            <h4 className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-paper/40 mb-5">Servicios</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/servicios/${s.slug}`} className="text-paper/70 hover:text-paper text-sm transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/galeria" className="text-paper/70 hover:text-paper text-sm transition-colors">Galería de proyectos</Link>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="text-[0.7rem] font-bold uppercase tracking-[0.2em] text-paper/40 mb-5">Contacto</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={`tel:${SITE.phone}`} className="flex items-center gap-3 text-paper/70 hover:text-paper transition-colors">
                  <Phone size={15} className="text-clay-light shrink-0" />
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-paper/70 hover:text-paper transition-colors break-all">
                  <Mail size={15} className="text-clay-light shrink-0" />
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-paper/70">
                <MapPin size={15} className="text-clay-light shrink-0" />
                Málaga capital · Costa del Sol, Andalucía
              </li>
              <li className="flex items-center gap-3 text-paper/70">
                <Clock size={15} className="text-clay-light shrink-0" />
                {SITE.hours}
              </li>
            </ul>
            <Link to="/contacto" className="btn mt-6 bg-clay text-white !px-5 !py-2.5 text-[0.7rem]">
              Ir a contacto
            </Link>
          </div>
        </div>

        {/* Barra inferior */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-paper/40">
          <p>© {new Date().getFullYear()} {SITE.legalName}. Todos los derechos reservados.</p>
          <div className="flex gap-6">
            <Link to="/aviso-legal" className="hover:text-paper transition-colors">Aviso legal</Link>
            <Link to="/politica-de-privacidad" className="hover:text-paper transition-colors">Privacidad</Link>
            <Link to="/terminos-y-condiciones" className="hover:text-paper transition-colors">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
